import { Input } from "components";
import React, { useState, useEffect } from 'react';
import { Box, Snackbar, Typography, Stack, Button } from '@mui/material';
import { userforgotPassword, validateOtp } from 'services';
import { useLocation, useNavigate } from 'react-router';
import LoadingButton from '@mui/lab/LoadingButton';
import MuiAlert, { AlertProps } from '@mui/material/Alert';
import CountdownTimer from "components/counter/counter";
import { EurofinsLogo } from 'components/svg/EurofinsLogo';
import { ElvisConnect } from 'components/svg/ElvisConnect';

export const Otp = () => {
    let navigate = useNavigate();
    const [otp, setOtp] = useState("");
    const [otpError, setOtpError] = useState(false);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);
    const [wrongError, setWrongError] = useState(false);
    const [resendCode, setResendCode] = useState(false);
    const [checked, setChecked] = useState(false);
    const location: any = useLocation();
    const userName = location?.state?.data;
    const [isDisabled, setIsDisabled] = useState(true);

    useEffect(() => {
        if (checked) {
            setOtpError(false);
        }
    }, [checked])

    const resendOtp = () => {
        userforgotPassword(userName).then((res: any) => {
            if (res.status === 200) {
                setResendCode(true);
                setLoading(false);
                setIsDisabled(true);
            } else {
                setWrongError(true);
            }
        }).finally(() => setLoading(false))
    }

    const verify = (e: any) => {
        e.preventDefault();
        setLoading(true);

        if (!otp) {
            setOtpError(true);
            return
        }
        validateOtp(otp).then((res: any) => {
            if (res?.status === 200 && res.data !== false) {
                navigate('/resetpassword', { state: { data: otp, email: userName } });
            } else {
                setError(true);
            }
        }).finally(() => {
            setLoading(false);
        })
    }

    const updateOtp = (event: any) => {
        const val = event.target.value;
        setOtpError(false);
        if (val.match(/[^0-9]/)) {
            return event.preventDefault();
        }
        setOtp(val);
    }

    const Alert = React.forwardRef<HTMLDivElement, AlertProps>(function Alert(
        props,
        ref,
    ) {
        return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
    });

    return (
        <div style={{ minHeight: '100vh', width: '100%', background: 'linear-gradient(to right, #003883, #ee7d11)' }}>
            <form onSubmit={verify} style={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                margin: 0,
            }}>
                <Box sx={{
                    display: 'flex',
                    alignItems: 'center',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    p: 3,
                    m: 1,
                    width: '400px',
                    bgcolor: 'background.paper',
                    borderRadius: 1,
                }}>
                    <div><EurofinsLogo /></div>
                    <div><ElvisConnect /></div>
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            flexDirection: 'column',
                            justifyContent: 'center',
                            p: 1,
                            m: 1,
                            bgcolor: 'background.paper',
                            borderRadius: 1,
                        }}
                    >
                        <Typography variant="h6" data-testid="otp-title" color="secondary.main">Enter 6-digit Verification Code</Typography>
                    </Box>
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'flex-end',
                            justifyContent: 'center',
                            width: '100%',
                            borderRadius: 1,
                        }}
                    >
                        <Input
                            required
                            error={otpError}
                            sx={{ width: '50%' }}
                            helperText={otpError ? "Please enter OTP" : ''}
                            disabled={checked}
                            onChange={updateOtp}
                            id="otp_number_1"
                            label="Enter OTP"
                            value={otp}
                            inputProps={{
                                inputMode: "numeric",
                                maxLength: 6,
                            }}
                        />
                    </Box>
                    <Box
                        sx={{
                            alignItems: 'center',
                            textAlign: 'center',
                            justifyContent: 'end',
                            width: '100%',
                            bgcolor: 'background.paper',
                            borderRadius: 1,
                        }}
                    >
                        {isDisabled ?
                            <Typography variant="h6" sx={{ color: '#003883', fontSize: '12px', marginTop: '10px' }}>
                                <CountdownTimer initialMinutes={4} initialSeconds={59} setIsDisabled={setIsDisabled} />
                            </Typography>
                            : <Button sx={{ marginTop: 2 }} variant="outlined" role="confirm" onClick={() => resendOtp()} data-testid="resend-otp" disabled={isDisabled}> Resend OTP </Button>
                        }
                        <LoadingButton loading={loading} type="submit" sx={{ marginTop: 2, marginLeft: 1 }} variant="contained" role="confirm">
                            Confirm
                        </LoadingButton>
                    </Box>
                </Box>
            </form>
            <Stack>
                <Snackbar open={error} autoHideDuration={6000} onClose={() => setError(false)}>
                    <Alert severity="error" onClose={() => setError(false)}>
                        Please provide the correct verification code!
                    </Alert>
                </Snackbar>
                <Snackbar open={resendCode} autoHideDuration={6000} onClose={() => setResendCode(false)}>
                    <Alert severity="success" onClose={() => setResendCode(false)}>
                        Your new OTP has been sent to the registered email
                    </Alert>
                </Snackbar>
                <Snackbar open={wrongError} autoHideDuration={6000} onClose={() => setWrongError(false)}>
                    <Alert onClose={() => setWrongError(false)} severity="warning">
                        Something went wrong please try again
                    </Alert>
                </Snackbar>
            </Stack>
        </div>
    )
}
